module.exports = __webpack_public_path__ + "media/images/application2/TalkCard__booking-details__count-d5dd47dec4de333e84c86a71fd8b1b76.svg";